/* AUTO-GENERATED from backend/settings/. Run `make generate-config` after backend changes. */
/* Do not edit by hand — edits will be overwritten on the next run. */

// ======================================================================
// Banks
// ======================================================================

export const BANK_ORDER = ["Fed", "ECB", "BoJ", "BoE", "SNB", "BOC", "RBA", "Riksbank", "Norges", "RBNZ"] as const satisfies readonly string[];

// ======================================================================
// Countries (economic outlook)
// ======================================================================

export const COUNTRY_CONFIG = {
  "AUS": {
    "available_timeframes": [
      "1y",
      "2y"
    ],
    "click_reveal_enabled": true,
    "code": "AUS",
    "default_timeframe": "2y",
    "display_name": "Australia",
    "display_order": 6,
    "nowcast_enabled": true,
    "recent_releases_enabled": "auto",
    "s3_nowcast_path": "data-exchange/Research/Dashboard/Nowcasts/AustraliaNowcast.csv",
    "s3_recession_path": "data-exchange/Research/Dashboard/Probabilities/AustraliaRecession.csv",
    "s3_releases_path": "data-exchange/Research/Dashboard/Nowcasts/AustraliaNowcastReleasesAll.csv",
    "upcoming_releases_enabled": false
  },
  "CHN": {
    "available_timeframes": [
      "1y",
      "2y"
    ],
    "click_reveal_enabled": true,
    "code": "CHN",
    "default_timeframe": "2y",
    "display_name": "China",
    "display_order": 5,
    "nowcast_enabled": true,
    "recent_releases_enabled": "auto",
    "s3_nowcast_path": "data-exchange/Research/Dashboard/Nowcasts/ChinaNowcast.csv",
    "s3_recession_path": "data-exchange/Research/Dashboard/Probabilities/ChinaRecession.csv",
    "s3_releases_path": "data-exchange/Research/Dashboard/Nowcasts/ChinaNowcastReleasesAll.csv",
    "upcoming_releases_enabled": false
  },
  "EA": {
    "available_timeframes": [
      "1y",
      "2y",
      "5y"
    ],
    "click_reveal_enabled": true,
    "code": "EA",
    "default_timeframe": "2y",
    "display_name": "Euro Area",
    "display_order": 2,
    "nowcast_enabled": true,
    "recent_releases_enabled": "auto",
    "s3_nowcast_path": "data-exchange/Research/Dashboard/Nowcasts/EuroAreaNowcast.csv",
    "s3_recession_path": "data-exchange/Research/Dashboard/Probabilities/EuroAreaRecession.csv",
    "s3_releases_path": "data-exchange/Research/Dashboard/Nowcasts/EuroAreaNowcastReleasesAll.csv",
    "upcoming_releases_enabled": false
  },
  "JPN": {
    "available_timeframes": [
      "1y",
      "2y",
      "5y"
    ],
    "click_reveal_enabled": true,
    "code": "JPN",
    "default_timeframe": "2y",
    "display_name": "Japan",
    "display_order": 4,
    "nowcast_enabled": true,
    "recent_releases_enabled": "auto",
    "s3_nowcast_path": "data-exchange/Research/Dashboard/Nowcasts/JapanNowcast.csv",
    "s3_recession_path": "data-exchange/Research/Dashboard/Probabilities/JapanRecession.csv",
    "s3_releases_path": "data-exchange/Research/Dashboard/Nowcasts/JapanNowcastReleasesAll.csv",
    "upcoming_releases_enabled": false
  },
  "UK": {
    "available_timeframes": [
      "1y",
      "2y",
      "5y"
    ],
    "click_reveal_enabled": true,
    "code": "UK",
    "default_timeframe": "2y",
    "display_name": "United Kingdom",
    "display_order": 3,
    "nowcast_enabled": true,
    "recent_releases_enabled": "auto",
    "s3_nowcast_path": "data-exchange/Research/Dashboard/Nowcasts/UKNowcast.csv",
    "s3_recession_path": "data-exchange/Research/Dashboard/Probabilities/UKRecession.csv",
    "s3_releases_path": "data-exchange/Research/Dashboard/Nowcasts/UKNowcastReleasesAll.csv",
    "upcoming_releases_enabled": false
  },
  "US": {
    "available_timeframes": [
      "1y",
      "2y",
      "5y",
      "10y",
      "30y"
    ],
    "click_reveal_enabled": true,
    "code": "US",
    "default_timeframe": "2y",
    "display_name": "United States",
    "display_order": 1,
    "nowcast_enabled": true,
    "recent_releases_enabled": true,
    "s3_nowcast_path": "data-exchange/Research/Dashboard/Nowcasts/USNowcast.csv",
    "s3_recession_path": "data-exchange/Research/Dashboard/Probabilities/USRecession.csv",
    "s3_releases_path": "data-exchange/Research/Dashboard/Nowcasts/USNowcastReleasesAll.csv",
    "upcoming_releases_enabled": true
  }
} as const;

/** Country codes ordered by ``display_order`` (stable across runs). */
export const COUNTRIES_BY_DISPLAY_ORDER = ["US", "EA", "UK", "JPN", "CHN", "AUS"] as const;

// ======================================================================
// Topic groups (4 groups x 2 views = 8 v2 topics)
// ======================================================================

/** Materialised v2 topic vocabulary, ordered group-major. */
export const TOPIC_KEYS_V2 = ["monetary_policy_stance", "monetary_policy_guidance", "inflation_review", "inflation_outlook", "employment_review", "employment_outlook", "activity_review", "activity_outlook"] as const;

// ======================================================================
// Portfolio funds
// ======================================================================

export const FUND_IDS = ["mars-dar-nn", "mars-fidelity-balanced", "mars-fidelity-conservative", "mars-fqm", "mars-qmas", "mars-qmas-nn"] as const satisfies readonly string[];
export type FundId = (typeof FUND_IDS)[number];
